import { CSSProperties, ReactNode } from 'react';

import { Button } from 'antd-mobile';
import styled from 'styled-components';

interface Props {
  children?: ReactNode;
  icon: ReactNode;
  onClick?: any;
  width?: string;
  height?: string;
  border?: string;
  disabled?: boolean;
}

const SButton = styled(Button)<Props | CSSProperties>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  border: ${({ border }) => border};
  font-size: 16px;
`;

const IconButton = ({ children, icon, onClick, width, height, border, disabled }: Props) => {
  return (
    <SButton
      fill="none"
      onClick={onClick}
      width={width}
      height={height}
      border={border}
      disabled={disabled}
    >
      {icon}
      {children}
    </SButton>
  );
};

export default IconButton;
